import { render, staticRenderFns } from "./paginationmincopy.vue?vue&type=template&id=add6f446"
import script from "./paginationmincopy.vue?vue&type=script&lang=js"
export * from "./paginationmincopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports